<template>
    <div class="download-box">
        <div class="download-tip-box confirm-box">
            <div class="tip-box ">
                <div class="two-img-box">
                    <div class="left-img">
                        <div class="term">如何免费试用?
                        </div>
                        <div class="text">1、分别下载电脑端和手机端app文件(需要安卓手机 )
                        </div>
                        <div class="text"> 2、安装好手机app后注册账号，在电脑端用该账号登陆</div>
                    </div>
                    <div class="right-img">
                        <img src="@/assets/image/down/work.jpg" alt="">
                    </div>
                </div>
            </div>
            <div class="dowloady-system ">
                <div class="download-list">
                    <div class="card-download">
                        <div class="item-card">
                            <div class="title">YOBONKE手机App
                            </div>
                            <!-- <div class="tip">支持安卓系统6.1或以上
                            </div> -->
                            <div class="img-box" style="width: 128px;">
                                <img src="@/assets/image/down/phone.png" alt="">
                            </div>
                            <div class="btn-download" @click="downHandle('apk')">Android下载(64位)
                            </div>
                            <div class="btn-download" @click="downHandle('apk32')">Android下载(32位)
                            </div>
                            <div class="tip">安卓市场或应用市场

                                搜索 YOBONKE 免费下载

                            </div>
                        </div>
                        <div class="item-card">
                            <div class="title">YOBONKE电话助手
                            </div>
                            <!-- <div class="tip">支持win10、win11
                            </div> -->
                            <div class="img-box"><img src="@/assets/image/down/windows.png" alt=""></div>
                            <div class="btn-download" @click="downHandle('zip')">Windows下载
                            </div>
                            <div class="btn-download" @click="downHandle('zipmini')">Windows下载(mini版)
                            </div>
                            <div class="tip">电脑控制手机或者座机
                                打电话或发短信

                            </div>
                        </div>
                        <div class="item-card">
                            <div class="title">管理系统
                            </div>
                            <!-- <div class="tip">支持win10、win11
                            </div> -->
                            <div class="img-box"><img src="@/assets/image/down/windows.png" alt=""></div>
                            <div class="btn-download" @click="downHandle('win')">Windows打开
                            </div>
                            <div class="tip">有座席管理,CRM客户管理

                                通话记录,录音,统计报表等

                            </div>
                        </div>
                    </div>

                    <!-- <div class="other-down">
                        <div class="other-term">其他下载</div>
                        <div class="other-btn">单机版 YOBONKE电话助手
                        </div>
                        <div class="other-btn">websocket版本 YOBONKE

                        </div>
                        <div class="other-btn">XP专用版 YOBONKE电话助手

                        </div>
                        <div class="other-btn">高分辨率版 YOBONKE电话助手

                        </div>
                    </div> -->
                </div>
            </div>
            <div class="software-money confirm">
                <div class="term" style="border-bottom: none;">
                    YOBONKE系统软件资费
                </div>
                <div class="table-box">
                    <table>
                        <tr>
                            <th>收费标准</th>
                            <th>一个月</th>
                            <th>一季度</th>
                            <th>一年</th>

                        </tr>
                        <tr>
                            <td>1个座席</td>
                            <td>18.8元</td>
                            <td>50元</td>
                            <td>188元</td>
                        </tr>
                        <tr>
                            <td>10个座席</td>
                            <td>188元</td>
                            <td>500元</td>
                            <td>1880元</td>
                        </tr>
                        <tr>
                            <td>20个座席</td>
                            <td>376元</td>
                            <td>1000元</td>
                            <td>3700元</td>
                        </tr>


                    </table>



                </div>

            </div>
            <!-- <div class="phone-money confirm">
                <div class="term" style="border-bottom: none;">
                    YOBONKE电脑拨号usb电话价格
                </div>
                <div class="table-box">
                    <table>
                        <tr>
                            <th>话机类型</th>
                            <th>话机配套单机版电话助手拨号软件</th>

                        </tr>
                        <tr>
                            <td>电话线版usb话机</td>
                            <td>280元/台</td>

                        </tr>
                        <tr>
                            <td>电信版无线播卡usb话机</td>
                            <td>350元/台</td>

                        </tr>
                        <tr>
                            <td>移动联通版无线插卡usb话机</td>
                            <td>350元/台</td>

                        </tr>
                        <tr>
                            <td>4G全网通无线usb话机</td>
                            <td>480元/台</td>

                        </tr>
                    </table>



                </div>

            </div> -->
            <div class="download-way confirm">
                <div class="term">合作下载渠道</div>
                <div class="brand-box download">
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/logo1.png" alt=""></div>
                        <div class="brand-text">华为应用市场
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/logo2.png" alt=""></div>
                        <div class="brand-text">腾讯应用宝
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/logo3.png" alt=""></div>
                        <div class="brand-text">360手机助手
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/logo4.png" alt=""></div>
                        <div class="brand-text">PC6安卓网
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/logo5.png" alt=""></div>
                        <div class="brand-text">豌豆荚
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/logo6.png" alt=""></div>
                        <div class="brand-text">百度应用市场
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/logo7.png" alt=""></div>
                        <div class="brand-text">小米应用商店
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/logo8.png" alt=""></div>
                        <div class="brand-text">太平洋电脑网
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/logo9.png" alt=""></div>
                        <div class="brand-text">中关村在线
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/logo10.png" alt=""></div>
                        <div class="brand-text">非凡软件站
                        </div>
                    </div>

                </div>
            </div>
            <div class="phone-brand confirm">
                <div class="term">对手机或者座机进行后台管理
                </div>
                <div class="brand-box">
                    <div class="item-box">
                        <div class="brand-img">
                            <img src="@/assets/image/down/xiaomi.png" alt="">
                        </div>
                        <div class="brand-text">小米</div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/huawei.png" alt=""></div>
                        <div class="brand-text">华为</div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/nubia.png" alt=""></div>
                        <div class="brand-text">努比亚
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/yijia.png" alt=""></div>
                        <div class="brand-text">一加</div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/oppo.png" alt=""></div>
                        <div class="brand-text">oppo</div>
                    </div>
                    <div class="item-box">
                        <div class="brand-img"><img src="@/assets/image/down/pingguo.png" alt=""></div>
                        <div class="brand-text">苹果</div>
                    </div>

                </div>
            </div>
            <div class="buy-channel confirm">
                <div class="term">
                    YOBONKE产品在线购买渠道
                </div>
                <div class="buy-channel-item">
                    <div class="item-box">
                        <div class="icon-box"><img src="@/assets/image/down/bot1.png" alt=""></div>
                        <div class="info-title">手机座席软件</div>
                        <div class="text">电脑实时控制手机自动拨号
                        </div>
                        <div class="btn">点击购买</div>
                    </div>
                    <div class="item-box">
                        <div class="icon-box"><img src="@/assets/image/down/bot2.png" alt=""></div>
                        <div class="info-title">usb座机
                        </div>
                        <div class="text">电脑实时控制usb话机自动拨号
                        </div>
                        <div class="btn">点击购买</div>
                    </div>
                    <div class="item-box">
                        <div class="icon-box"><img src="@/assets/image/down/bot3.png" alt=""></div>
                        <div class="info-title">电话管理系统
                        </div>
                        <div class="text">对手机或者座机进行后台管理
                        </div>
                        <div class="btn">点击购买</div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>


export default {
    methods: {
        downHandle(way) {
            let url = ''
            if (way == 'apk') {
                url = 'https://www.hbsyyrj.cn/YOBONEK_64x.apk' // 64位
            }
            else if (way == 'apk32') {
                url = 'https://www.hbsyyrj.cn/YOBONEK_32x.apk' // 64位
            } else if (way == 'zip') {
                url = 'https://www.hbsyyrj.cn/YOBONEK.zip'
            }
            else if (way == 'zipmini') {
                url = 'https://www.hbsyyrj.cn/ybk_min.zip'
            }
            if (way == 'win') {
                return window.open('http://bcrms.hbsyyrj.cn/')
            }
            window.location.href = url
        }
    }

}
</script>

<style lang="less" scoped>
.download-box {
    padding-bottom: 30px;
}

.confirm-box>.confirm {
    width: 1077px;
    // height: 100%;
    margin: 0 auto;

    .term {
        text-align: center;
        font-size: 30px;
        border-bottom: 1px solid #cdcdcd;
        margin-bottom: 20px;
        padding: 20px 0;
        color: #101010;
    }

    .table-box {
        table {
            width: 100%;
            border: none;
            border-collapse: collapse;

            tr {

                th,
                td {
                    width: 50%;
                    text-align: center;
                    height: 57px;
                }

                th {
                    background-color: #009fe9;
                    color: #fff;
                    font-size: 14px;
                }

                td {
                    background-color: #fff;
                    color: #101010;
                }
            }
        }


    }

    // background: red;
    &:nth-of-type(n+3) {
        // background-color: red;
        padding: 10px 150px;
    }
}


.dowloady-system {
    background: #e0dfdf;

    .download-list {
        width: 1077px;
        margin: 0 auto;
        // background-color: blue;
        padding: 20px 0;

        .card-download {

            display: flex;
            justify-content: space-between;

            .item-card {
                width: 328px;
                height: 450px;
                background-color: #fff;
                text-align: center;

                .title {
                    color: #101010;
                    font-size: 20px;
                    padding-top: 22px;
                }

                .tip {
                    color: #747577;
                    font-size: 16px;
                    padding: 0 60px;
                }

                .btn-download {
                    width: 200px;
                    height: 45px;
                    line-height: 45px;
                    text-align: center;
                    border-radius: 4px;
                    background-color: rgba(1, 176, 187, 1);
                    color: #FFF;
                    cursor: pointer;
                    margin: 0px auto 7px;

                }

                .img-box {
                    width: 300px;
                    height: 200px;
                    margin: 15px auto;

                    img {
                        width: 100%;
                        height: 100%
                    }

                }
            }
        }

        .other-down {
            color: #747577;
            font-size: 22px;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            padding-top: 20px;

            .other-btn {
                cursor: pointer;
                width: 216px;
                height: 45px;
                line-height: 45px;
                background-color: rgba(0, 159, 233, 1);
                color: #fff;
                font-size: 16px;
                text-align: center;
                box-shadow: 0px 2px 6px 0px rgba(60, 60, 60, 0.4);
            }
        }


    }
}

.software-money,
.confirm {
    .table-box {
        tr {

            th,
            td {
                width: 25% !important;
            }
        }
    }
}

.tip-box {
    height: 515px;
    background-color: #efefef;

    .two-img-box {
        width: 1077px;
        height: 100%;
        margin: 0 auto;
        position: relative;

        .left-img,
        .right-img {
            width: 604px;
            height: 357px;
            position: absolute;

            img {
                height: 100%;
                width: 100%;
            }

        }

        .left-img {
            background-color: blue;
            bottom: 38px;
            background: url(@/assets/image/down/bg.jpg) no-repeat;
            background-size: 100% 100%;
            z-index: 1;

            color: #fff;
            padding: 30px;
            font-size: 20px;

            .term {
                font-size: 45px;
                font-weight: bold;
            }

            .text {
                line-height: 40px;
            }
        }

        .right-img {
            // background-color: red;
            right: 0;
            top: 74px;
        }
    }
}


.phone-brand,
.download-way {
    .brand-box {
        display: flex;
        flex-wrap: wrap;

        .item-box {

            width: 300px;
            margin: 0 5px 35px 0;
            // background-color: #999;
            width: calc((100% - 10px) / 3); // 这里的10px = (分布个数3-1)*间隙5px, 可以根据实际的分布个数和间隙区调整
            min-width: calc((100% - 10px) / 3); // 加入min-width、max-width后每个child的宽度就生效了
            max-width: calc((100% - 10px) / 3);

            &:nth-child(3n) {
                margin-right: 0; // 去除第3n个的margin-right
            }

            .brand-img {
                width: 113px;
                height: 113px;

                img {
                    width: 100%;
                    height: 100%;
                }

                // border: 1px solid #000;
                img {
                    width: 100%;
                    height: 100%;
                }

                margin: 0 auto;
            }

            .brand-text {
                color: #666666;
                font-size: 18px;
                text-align: center;
            }
        }
    }

    .download {
        .item-box {
            width: calc((100%) / 5);
            min-width: calc((100%) / 5); // 加入min-width、max-width后每个child的宽度就生效了
            max-width: calc((100%) / 5);
            margin-right: 0;
        }

        &:nth-child(5n) {
            margin-right: 0; // 去除第3n个的margin-right
        }

    }
}



.buy-channel {

    .buy-channel-item {
        display: flex;
        justify-content: space-around;
        padding-top: 20px;

        .item-box {
            display: flex;
            flex-direction: column;
            align-items: center;

            .icon-box {
                width: 120px;
                height: 120px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .info-title {
                font-weight: bold;
                font-size: 16px;
                margin: 15px 0;
            }

            .text {
                font-size: 14px;
                color: #666666;
                margin-bottom: 15px;
            }

            .btn {
                width: 164px;
                height: 52px;
                cursor: pointer;
                color: #fff;
                border-radius: 4px;
                background-color: #4ebdf0;
                text-align: center;
                line-height: 52px;
            }
        }
    }
}
</style>
